import { createSlice } from '@reduxjs/toolkit'
import { ProgramEditSuccessType, ProgramEditErrorType } from '../Shared/types'

export interface ProgramSuccessState {
  programEditSuccess: ProgramEditSuccessType
  programEditError: ProgramEditErrorType
}

const INITIAL_STATE: ProgramSuccessState = {
  programEditSuccess: {
    qtf: [],
    flex: [],
    transitPass: [],
    micromobility: [],
    grh: [],
    coupon: [],
    reportedUsage: [],
  },
  programEditError: {
    qtf: [],
    flex: [],
    transitPass: [],
    micromobility: [],
    grh: [],
    coupon: [],
    reportedUsage: [],
  },
}

const programSuccessSlice = createSlice({
  name: 'programSuccess',
  initialState: INITIAL_STATE,
  reducers: {
    addSuccessfulEditProgramIds: (state, action) => {
      state.programEditSuccess[action.payload.type] = [
        ...state.programEditSuccess[action.payload.type],
        action.payload.id,
      ]
    },
    addProgramEditError: (state, action) => {
      state.programEditError[action.payload.type] = [
        ...state.programEditError[action.payload.type],
        action.payload.id,
      ]
    },
    setNewEditCycleCleanup: (state) => {
      return INITIAL_STATE
    },
  },
})

export const programSuccessReducer = programSuccessSlice.reducer
export const programSuccessReducers = {
  ...programSuccessSlice.actions,
}
